import { createRouter, createWebHistory } from 'vue-router'


import toolsRoutes from "@/router/toolsRoutes"
// import RouterManager from "@/router/RouterManager";





let routerOptions = {
	history: createWebHistory(),
	routes: [

		...toolsRoutes,

	],
}


let router = createRouter(routerOptions)

export {
	router
}

export default (authManager, store) => {
	return {router}
}
